import { useObjectActionQuery } from '../api/object'
import { CurrencyFormatter } from './currency-formatter'

export function Due({ id }: { id: string }) {
	const { data } = useObjectActionQuery<{ value?: string }>('reservation', id, 'overdue')
	return <DueFormatter value={data?.value} />
}

export function DueFormatter({ value }: { value?: string | number }) {
	if (value === '' || value == null) return null

	const valueAsNumber = typeof value === 'string' ? parseFloat(value) : value

	if (valueAsNumber < 0) {
		return (
			<span className="px-2 py-1 rounded-xl bg-green-50 text-xxs font-semibold text-green-700">
				V pořádku [<CurrencyFormatter value={value} />]
			</span>
		)
	}

	if (valueAsNumber === 0) {
		return (
			<span className="px-2 py-1 rounded-xl bg-green-50 text-xxs font-semibold text-green-700">
				V pořádku
			</span>
		)
	}

	return (
		<span className="px-2 py-1 rounded-xl bg-[#fdf2fa] text-xxs font-semibold text-[#dd2590]">
			<CurrencyFormatter value={value} />
		</span>
	)
}
